import { useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'
import { useCare } from '../contexts/CareContext'

export const PENDING_INVITE_KEY = 'mapa.pendingInvite'

export default function InvitePage() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const { session, loading } = useAuth()
  const { reload } = useCare()
  const navigate = useNavigate()
  const [status, setStatus] = useState('checking') // checking | need-auth | accepting | error
  const ran = useRef(false)

  useEffect(() => {
    if (loading || ran.current) return
    if (!token) { setStatus('error'); return }

    if (!session) {
      // Remember the invite so it's accepted right after they sign up / log in.
      localStorage.setItem(PENDING_INVITE_KEY, token)
      setStatus('need-auth')
      return
    }

    ran.current = true
    setStatus('accepting')
    ;(async () => {
      const { data, error } = await supabase.rpc('accept_invite', { p_token: token })
      localStorage.removeItem(PENDING_INVITE_KEY)
      if (error || !data) {
        setStatus('error')
        return
      }
      await reload()
      navigate('/', { replace: true })
    })()
  }, [loading, session, token, reload, navigate])

  return (
    <div className="screen">
      <div className="container center" style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 14 }}>
        <div style={{ fontSize: 44 }}>✉️</div>
        {status === 'checking' || status === 'accepting' ? (
          <>
            <h1 className="title">Joining the care team…</h1>
            <div className="spinner spinner-teal" style={{ alignSelf: 'center' }} />
          </>
        ) : status === 'need-auth' ? (
          <>
            <h1 className="title">You've been invited</h1>
            <p className="subtitle">Sign up or log in to join the care team. We'll add you automatically.</p>
            <button className="btn btn-lg" onClick={() => navigate('/auth')}>Continue</button>
          </>
        ) : (
          <>
            <h1 className="title">This invite isn't valid</h1>
            <p className="subtitle">It may have already been used or expired. Ask the admin to send a new one.</p>
            <button className="btn btn-ghost" onClick={() => navigate('/')}>Go to Mapa Care</button>
          </>
        )}
      </div>
    </div>
  )
}
